/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ex_NoteInputs */

const en_formatter_ex_note = /** @type {(inputs: Formatter_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notice that the nested object and the array each gain one indentation level, and that array elements sit on their own lines. The values are untouched.`)
};

const ko_formatter_ex_note = /** @type {(inputs: Formatter_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 객체와 배열이 각각 들여쓰기 한 단계를 얻고, 배열 요소가 각자 줄을 차지하는 것을 보세요. 값은 손대지 않았습니다.`)
};

const ja_formatter_ex_note = /** @type {(inputs: Formatter_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたオブジェクトと配列がそれぞれインデント 1 段階を得て、配列要素が各自の行を占めることに注目してください。値には手を付けていません。`)
};

/**
* | output |
* | --- |
* | "Notice that the nested object and the array each gain one indentation level, and that array elements sit on their own lines. The values are untouched." |
*
* @param {Formatter_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ex_note = /** @type {((inputs?: Formatter_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ex_note(inputs)
	if (locale === "ko") return ko_formatter_ex_note(inputs)
	return ja_formatter_ex_note(inputs)
});